import * as React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Karta menu z ołówkiem — ikona edycji pozycji menu.
 *
 * Zastępuje generyczny `EditIcon` z Material Icons: sam ołówek znaczy "edytuj
 * cokolwiek", a ta ikona mówi "edytuj kartę menu", więc na liście produktów nie
 * myli się z edycją użytkownika czy prowizji.
 *
 * Rysunek jest liniowy (`fill: none` + `stroke: currentColor`), a nie wypełniony
 * jak domyślne Material Icons — dlatego wypełnienie i obrys ustawiamy tutaj,
 * nadpisując `fill: currentColor`, które SvgIcon nakłada swoją klasą. Kolor dalej
 * bierze się z `currentColor`, więc `color="error"` czy kolor tekstu w liście
 * działają bez zmian.
 */
export const MenuCardPencilIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
    sx={{
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 1.7,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      ...props.sx,
    }}
  >
    <path d="M5 3.5h11a2 2 0 0 1 2 2V11" />
    <path d="M18 17.5v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-15a2 2 0 0 1 2-2" />
    <path d="M7 8h7M7 11.5h7M7 15h4" />
    <path d="M19.6 11.2a1.8 1.8 0 0 1 2.5 2.5l-5 5-3.2.7.7-3.2z" />
  </SvgIcon>
);
